import { observable } from 'mobx'
import icons from '../assets/icons'

export type $BottomMessageButton = {
  title: string
  onPress?: () => void
  color?: 'primary' | 'secondary' | 'error'
  type: 'TextButton' | 'RectButton'
  rectButtonSize?: 'small' | 'medium' | 'large'
}

export interface $BottomMessageData {
  type?: 'card'
  heading?: string
  title?: string
  body?: string
  textAlign?: 'left' | 'right' | 'center'
  bannerImage?: string
  extraComponent?: React.ReactNode
  icon?: {
    type: 'circleIcon'
    iconName: keyof typeof icons
    iconType?: 'custom'
    color?: 'primary' | 'secondary' | 'green'
    iconColor?: 'primary' | 'secondary' | 'green'
  }
  actions?: Array<$BottomMessageButton>
  canDismiss?: boolean
}

class BottomMessageHandler {
  @observable accessor visible = false
  @observable accessor messageData: $BottomMessageData = {
    body: '',
  }

  showBottomMessage = (messageData: $BottomMessageData) => {
    this.messageData = messageData
    this.visible = true
  }

  hideBottomMessage = () => {
    this.visible = false
  }
}

export default BottomMessageHandler